import React from 'react';
import Button from 'shared/components/UC/Button';
import styles from './UserChangeConfirmationModal.module.css';

export interface ChangeItem {
  field: string;
  label: string;
  oldValue: any;
  newValue: any;
}

export interface UserChangeConfirmationModalProps {
  isOpen: boolean;
  changes: ChangeItem[];
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

const UserChangeConfirmationModal: React.FC<
  UserChangeConfirmationModalProps
> = ({ isOpen, changes, onConfirm, onCancel, isLoading = false }) => {
  if (!isOpen) return null;

  const formatValue = (value: any): string => {
    if (value === null || value === undefined || value === '') return '-';
    if (typeof value === 'boolean') return value ? 'Sí' : 'No';
    if (typeof value === 'number') return value.toString();
    return value;
  };

  return (
    <div className={styles.modalOverlay} onClick={onCancel}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2>Confirmar Cambios</h2>
          <button
            className={styles.closeButton}
            onClick={onCancel}
            aria-label="Cerrar"
          >
            ×
          </button>
        </div>

        <div className={styles.modalBody}>
          <p className={styles.modalDescription}>
            Estás a punto de guardar los siguientes cambios:
          </p>

          {changes.length === 0 ? (
            <p className={styles.noChanges}>No hay cambios para guardar.</p>
          ) : (
            <div className={styles.changesList}>
              {changes.map((change, index) => (
                <div key={index} className={styles.changeItem}>
                  <div className={styles.changeLabel}>{change.label}</div>
                  <div className={styles.changeValues}>
                    <div className={styles.oldValue}>
                      <span className={styles.valueLabel}>Anterior:</span>
                      <span className={styles.value}>
                        {formatValue(change.oldValue)}
                      </span>
                    </div>
                    <div className={styles.arrow}>→</div>
                    <div className={styles.newValue}>
                      <span className={styles.valueLabel}>Nuevo:</span>
                      <span className={styles.value}>
                        {formatValue(change.newValue)}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className={styles.modalFooter}>
          <Button onClick={onCancel} variant="secondary" disabled={isLoading}>
            Cancelar
          </Button>
          <Button
            onClick={onConfirm}
            variant="primary"
            disabled={isLoading || changes.length === 0}
          >
            {isLoading ? 'Guardando...' : 'Confirmar y Guardar'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UserChangeConfirmationModal;
